import React from 'react';

import Tag from '@amzn/meridian/tag';

export const ServiceTag: React.FC<{ name: string }> = (props) => {
    return <Tag type={'success'}>{props.name}</Tag>;
};
